module.exports = require("dompurify");


//////////////////
// WEBPACK FOOTER
// external "dompurify"
// module id = 647
// module chunks = 0